import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'app-number-of-steppers',
  templateUrl: './number-of-steppers.component.html',
  styleUrls: ['./number-of-steppers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [InputNumberModule, FormsModule, ReactiveFormsModule],
})
export class NumberOfSteppersComponent {
  @Input() requiredBedAsterisk = '';
  @Input() requiredBathAsterisk = '';
  @Input() formControlBedCount!: UntypedFormControl;
  @Input() formControlBathCount!: UntypedFormControl;
  @Input() formControlHalfBathCount!: UntypedFormControl;

  validateBedCount(event: any) {
    this.formControlBedCount.patchValue(event.value);
    this.formControlBedCount.markAsDirty();
  }

  validateBathCount(event: any) {
    this.formControlBathCount.patchValue(event.value);
    this.formControlBathCount.markAsDirty();
  }
}
